"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RestoreDefaultDesign = exports.AlertCheckExpr = exports.ReportCancel = exports.AlertOrder = exports.SaveRowViewColumnsDesign = exports.RowViewColumnsDesign = exports.AlertChoose = exports.AlertDelete = exports.AlertSave = exports.TableViewColumnsDesign = exports.AlertChooses = exports.AlertList = exports.CountFetch = exports.Links = exports.CheckModules = exports.CheckModule = exports.whoAmI = exports.formSystemConstants = exports.GeneralAbout = exports.dataStoreGet = exports.dataStoreSet = exports.setHostName = exports.setBaseUrl = exports.batch = exports.columns = exports.recordsFetch = exports.help = exports.recordEdit = exports.fieldSelect = exports.fieldUpdate = exports.recordSave = exports.recordDelete = exports.warningApprove = exports.recordUndo = exports.fieldUndo = exports.end = exports.subforms = exports.subform = exports.statuses = exports.actions = exports.actionEnd = exports.action = exports.olaps = exports.recordColors = exports.htmlSignature = exports.htmlSave = exports.htmlFetch = exports.htmlUnlock = exports.recordZoom = exports.start = void 0;
exports.GetCoverLetters = exports.GetMessageColumns = exports.UploadImage = exports.PackageSet = exports.PackageChange = exports.SystemPackages = exports.SaveTableViewColumnsDesign = exports.SaveActionsDesign = exports.ActionsDesign = exports.SaveSubformsDesign = exports.SubformsDesign = void 0;
var nform_1 = require("./nform");
var moment = require("moment-timezone");
var protobufjs_1 = require("protobufjs");
var cross_fetch_1 = require("cross-fetch");
var utils_1 = require("./utils");
var https = require('https');
if (https.Agent) {
    var httpsAgent = new https.Agent({
        rejectUnauthorized: false,
        keepAlive: true,
    });
}
//H:\sources\avia\go_protos>pbjs -t static-module -w commonjs -o nform.js common/*.proto netitems/form/*.proto netitems/metadata/*.proto netitems/shared/*.proto
//H:\sources\avia\go_protos>pbts -o nform.d.ts nform.js
var baseUrl;
var hostName;
function getTimeAndPlace(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var loc = ':' + ((_a = props === null || props === void 0 ? void 0 : props.Location) === null || _a === void 0 ? void 0 : _a.Latitude) + ':' + ((_b = props === null || props === void 0 ? void 0 : props.Location) === null || _b === void 0 ? void 0 : _b.Longitude) + ':' + ((_c = props === null || props === void 0 ? void 0 : props.Location) === null || _c === void 0 ? void 0 : _c.Address);
    var tz = (_d = props === null || props === void 0 ? void 0 : props.Timezone) === null || _d === void 0 ? void 0 : _d.IANA;
    if (!tz) {
        tz = (_e = moment.tz) === null || _e === void 0 ? void 0 : _e.guess();
        if (!tz)
            tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    var offset = (_f = props === null || props === void 0 ? void 0 : props.Timezone) === null || _f === void 0 ? void 0 : _f.Diff;
    if (!offset) {
        offset = -new Date().getTimezoneOffset();
        if ((_g = props === null || props === void 0 ? void 0 : props.Timezone) === null || _g === void 0 ? void 0 : _g.IANA)
            offset = moment.tz((_h = props === null || props === void 0 ? void 0 : props.Timezone) === null || _h === void 0 ? void 0 : _h.IANA).utcOffset();
    }
    return offset + (loc ? loc : '') + (tz ? '@TZ@' + tz : '');
}
function otherInfo(props) {
    var _a, _b, _c, _d;
    var appid = '';
    var appkey = '';
    var debugserver = '';
    if ((_a = props === null || props === void 0 ? void 0 : props.Asapi) === null || _a === void 0 ? void 0 : _a.ID)
        appid = 'appid_' + ((_b = props.Asapi) === null || _b === void 0 ? void 0 : _b.ID) + ',';
    if ((_c = props === null || props === void 0 ? void 0 : props.Asapi) === null || _c === void 0 ? void 0 : _c.Key)
        appkey = 'appkey_' + ((_d = props.Asapi) === null || _d === void 0 ? void 0 : _d.Key) + ',';
    if (props === null || props === void 0 ? void 0 : props.Debug)
        debugserver = "debug,".concat(props.DebugServer);
    return ('<OtherInfo xmlns="PriorityNS">app_' + (props === null || props === void 0 ? void 0 : props.ApplicationName) + ',' + appid + appkey + debugserver + '</OtherInfo>');
}
function gmtDates() {
    var cr = new Date();
    var exp = new Date(cr);
    exp.setMinutes(cr.getMinutes() + 6);
    return '<u:Created>' + cr.toISOString() + '</u:Created><u:Expires>' + exp.toISOString() + '</u:Expires>';
}
function getHostName() {
    return "<Hostname xmlns=\"PriorityNS\">".concat(hostName || '', "</Hostname>");
}
function envelopeStart(props, curop) {
    var _a, _b, _c, _d;
    return "<s:Envelope xmlns:s=\"http://schemas.xmlsoap.org/soap/envelope/\">\n    <s:Header>\n        <Language xmlns=\"PriorityNS\">".concat(props === null || props === void 0 ? void 0 : props.Language, "</Language>\n        ").concat(getHostName(), "\n        <WinUser xmlns=\"PriorityNS\"></WinUser>\n        <UtcOffset xmlns=\"PriorityNS\">").concat(getTimeAndPlace(props), "</UtcOffset>\n        <Environment xmlns=\"PriorityNS\">").concat(props === null || props === void 0 ? void 0 : props.Dname, "</Environment>\n        <SilverLight xmlns=\"PriorityNS\">2</SilverLight>\n        ").concat(otherInfo(props), "\n        <Security s:mustUnderstand=\"1\" xmlns:u=\"http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-utility-1.0.xsd\" xmlns=\"http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-secext-1.0.xsd\">\n            <u:Timestamp u:Id=\"_0\">").concat(gmtDates(), "</u:Timestamp>\n            <UsernameToken>\n                <Username>").concat((_b = (_a = props === null || props === void 0 ? void 0 : props.Credentials) === null || _a === void 0 ? void 0 : _a.Simple) === null || _b === void 0 ? void 0 : _b.Userlogin, "\t").concat(props === null || props === void 0 ? void 0 : props.Tabulaini, "</Username>\n                <Password Type=\"http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-username-token-profile-1.0#PasswordText\">").concat((0, utils_1.escapeString)((_d = (_c = props === null || props === void 0 ? void 0 : props.Credentials) === null || _c === void 0 ? void 0 : _c.Simple) === null || _d === void 0 ? void 0 : _d.Password), "</Password>\n            </UsernameToken>\n        </Security>\n    </s:Header>\n    <s:Body>\n        <").concat(curop, " xmlns=\"http://tempuri.org/\">");
}
function envelopeEnd(curop) {
    return '</' + curop + '></s:Body></s:Envelope>';
}
function sendHttpRequest(base64, curop, props, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var str, req, response, text, message, splitted, buf64;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    str = protobufjs_1.util.base64.encode(base64, 0, base64.length);
                    //let str = btoa(unescape(encodeURIComponent(new TextDecoder().decode(base64))));
                    str = '<request>' + str + '</request>';
                    req = envelopeStart(props, curop) + str + envelopeEnd(curop);
                    return [4 /*yield*/, (0, cross_fetch_1.default)(baseUrl, {
                            method: 'POST',
                            headers: {
                                'content-type': 'text/xml; charset=utf-8',
                                SOAPAction: 'http://tempuri.org/IWCFService/' + curop,
                            },
                            signal: signal,
                            body: req,
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.text()];
                case 2:
                    text = _a.sent();
                    if (!response.ok) {
                        message = "An error has occured: ".concat(response.status, ", a ").concat(text);
                        throw new Error(message);
                    }
                    splitted = text.split(curop + 'Result>');
                    if (splitted.length < 2 || splitted[1].length <= 2)
                        text = '';
                    else
                        text = splitted[1].substring(0, splitted[1].length - 2);
                    buf64 = protobufjs_1.util.newBuffer(protobufjs_1.util.base64.length(text));
                    protobufjs_1.util.base64.decode(text, buf64, 0);
                    return [2 /*return*/, buf64];
            }
        });
    });
}
function start(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.StartRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormStart', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.StartRs.decode(res)];
            }
        });
    });
}
exports.start = start;
function recordZoom(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.RecordZoomRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormRecordZoom', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.RecordZoomRs.decode(res)];
            }
        });
    });
}
exports.recordZoom = recordZoom;
function htmlUnlock(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.HtmlUnlockRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormHtmlUnlock', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.HtmlUnlockRs.decode(res)];
            }
        });
    });
}
exports.htmlUnlock = htmlUnlock;
function htmlFetch(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.HtmlFetchRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormHtmlFetch', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.HtmlFetchRs.decode(res)];
            }
        });
    });
}
exports.htmlFetch = htmlFetch;
function htmlSave(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.HtmlSaveRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormHtmlSave', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.HtmlSaveRs.decode(res)];
            }
        });
    });
}
exports.htmlSave = htmlSave;
function htmlSignature(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.HtmlSignatureRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormHtmlSignature', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.HtmlSignatureRs.decode(res)];
            }
        });
    });
}
exports.htmlSignature = htmlSignature;
function recordColors(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.RecordColorsRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormRecordColors', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.RecordColorsRs.decode(res)];
            }
        });
    });
}
exports.recordColors = recordColors;
function olaps(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.OlapsRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormOlaps', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.OlapsRs.decode(res)];
            }
        });
    });
}
exports.olaps = olaps;
function action(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.ActionRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormAction', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.ActionRs.decode(res)];
            }
        });
    });
}
exports.action = action;
function actionEnd(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.ActionEndRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormActionEnd', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.ActionEndRs.decode(res)];
            }
        });
    });
}
exports.actionEnd = actionEnd;
function actions(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.ActionsRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormActions', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.ActionsRs.decode(res)];
            }
        });
    });
}
exports.actions = actions;
function statuses(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.StatusesRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormStatuses', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.StatusesRs.decode(res)];
            }
        });
    });
}
exports.statuses = statuses;
function subform(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.SubformRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormSubform', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.StartRs.decode(res)];
            }
        });
    });
}
exports.subform = subform;
function subforms(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.SubformsRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormSubforms', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.SubformsRs.decode(res)];
            }
        });
    });
}
exports.subforms = subforms;
function end(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.EndRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormEnd', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.EndRs.decode(res)];
            }
        });
    });
}
exports.end = end;
function fieldUndo(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.FieldUndoRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormFieldUndo', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.FieldUndoRs.decode(res)];
            }
        });
    });
}
exports.fieldUndo = fieldUndo;
function recordUndo(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.RecordUndoRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormRecordUndo', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.RecordUndoRs.decode(res)];
            }
        });
    });
}
exports.recordUndo = recordUndo;
function warningApprove(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.WarningApproveRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormWarningApprove', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.WarningApproveRs.decode(res)];
            }
        });
    });
}
exports.warningApprove = warningApprove;
function recordDelete(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.RecordDeleteRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormRecordDelete', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.RecordDeleteRs.decode(res)];
            }
        });
    });
}
exports.recordDelete = recordDelete;
function recordSave(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.RecordSaveRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormRecordSave', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.RecordSaveRs.decode(res)];
            }
        });
    });
}
exports.recordSave = recordSave;
function fieldUpdate(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.FieldUpdateRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormFieldUpdate', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.FieldUpdateRs.decode(res)];
            }
        });
    });
}
exports.fieldUpdate = fieldUpdate;
function fieldSelect(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.FieldSelectRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormFieldSelect', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.FieldSelectRs.decode(res)];
            }
        });
    });
}
exports.fieldSelect = fieldSelect;
function recordEdit(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.RecordEditRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormRecordEdit', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.RecordEditRs.decode(res)];
            }
        });
    });
}
exports.recordEdit = recordEdit;
function help(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.HelpRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormHelp', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.HelpRs.decode(res)];
            }
        });
    });
}
exports.help = help;
function recordsFetch(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.FetchRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormFetch', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.FetchRs.decode(res)];
            }
        });
    });
}
exports.recordsFetch = recordsFetch;
function columns(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.ColumnsRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormColumns', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.ColumnsRs.decode(res)];
            }
        });
    });
}
exports.columns = columns;
function batch(req, properties, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.BatchRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormBatch', properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.BatchRs.decode(res)];
            }
        });
    });
}
exports.batch = batch;
function setBaseUrl(url) {
    baseUrl = url;
}
exports.setBaseUrl = setBaseUrl;
function setHostName(hostname) {
    hostName = hostname;
}
exports.setHostName = setHostName;
function dataStoreSet(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.ngtw.DataStoreSetRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NGtwDataStoreSet', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.ngtw.DataStoreSetRs.decode(res)];
            }
        });
    });
}
exports.dataStoreSet = dataStoreSet;
function dataStoreGet(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.ngtw.DataStoreGetRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NGtwDataStoreGet', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.ngtw.DataStoreGetRs.decode(res)];
            }
        });
    });
}
exports.dataStoreGet = dataStoreGet;
function GeneralAbout(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.ngtw.GeneralAboutRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NGtwGeneralAbout', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.ngtw.GeneralAboutRs.decode(res)];
            }
        });
    });
}
exports.GeneralAbout = GeneralAbout;
function formSystemConstants(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.SystemConstantsRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormSystemConstants', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.SystemConstantsRs.decode(res)];
            }
        });
    });
}
exports.formSystemConstants = formSystemConstants;
function whoAmI(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.ngen.WhoAmIRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NGenWhoAmI', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.ngen.WhoAmIRs.decode(res)];
            }
        });
    });
}
exports.whoAmI = whoAmI;
function CheckModule(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.ngen.CheckModuleRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NGenCheckModule', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.ngen.CheckModuleRs.decode(res)];
            }
        });
    });
}
exports.CheckModule = CheckModule;
function CheckModules(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.ngen.CheckModulesRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NGenCheckModules', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.ngen.CheckModulesRs.decode(res)];
            }
        });
    });
}
exports.CheckModules = CheckModules;
function Links(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.ngen.LinkRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NGenLinks', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.ngen.LinkRs.decode(res)];
            }
        });
    });
}
exports.Links = Links;
function CountFetch(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.CountFetchRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormCountFetch', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.CountFetchRs.decode(res)];
            }
        });
    });
}
exports.CountFetch = CountFetch;
function AlertList(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.AlertListRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormAlertList', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.AlertListRs.decode(res)];
            }
        });
    });
}
exports.AlertList = AlertList;
function AlertChooses(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.AlertChoosesRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormAlertChooses', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.AlertChoosesRs.decode(res)];
            }
        });
    });
}
exports.AlertChooses = AlertChooses;
function TableViewColumnsDesign(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.TableViewColumnsDesignRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormTableViewColumnsDesign', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.TableViewColumnsDesignRs.decode(res)];
            }
        });
    });
}
exports.TableViewColumnsDesign = TableViewColumnsDesign;
function AlertSave(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.AlertSaveRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormAlertSave', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.AlertListRs.decode(res)];
            }
        });
    });
}
exports.AlertSave = AlertSave;
function AlertDelete(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.AlertDeleteRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormAlertDelete', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.EmptyRs.decode(res)];
            }
        });
    });
}
exports.AlertDelete = AlertDelete;
function AlertChoose(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.AlertChooseRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormAlertChoose', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.FieldSelectRs.decode(res)];
            }
        });
    });
}
exports.AlertChoose = AlertChoose;
function RowViewColumnsDesign(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.RowViewColumnsDesignRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormRowViewColumnsDesign', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.RowViewColumnsDesignRs.decode(res)];
            }
        });
    });
}
exports.RowViewColumnsDesign = RowViewColumnsDesign;
function SaveRowViewColumnsDesign(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.SaveRowViewColumnsDesignRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormSaveRowViewColumnsDesign', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.SaveRowViewColumnsDesignRs.decode(res)];
            }
        });
    });
}
exports.SaveRowViewColumnsDesign = SaveRowViewColumnsDesign;
function AlertOrder(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.AlertOrderRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormAlertOrder', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.EmptyRs.decode(res)];
            }
        });
    });
}
exports.AlertOrder = AlertOrder;
function ReportCancel(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.nrest.ReportCancelRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormReportCancel', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.nrest.ReportCancelRs.decode(res)];
            }
        });
    });
}
exports.ReportCancel = ReportCancel;
function AlertCheckExpr(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.AlertCheckExprRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormAlertCheckExpr', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.AlertCheckExprRs.decode(res)];
            }
        });
    });
}
exports.AlertCheckExpr = AlertCheckExpr;
function RestoreDefaultDesign(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.RestoreDefaultDesignRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormRestoreDefaultDesign', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.RestoreDefaultDesignRs.decode(res)];
            }
        });
    });
}
exports.RestoreDefaultDesign = RestoreDefaultDesign;
function SubformsDesign(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.SubformsDesignRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormSubformsDesign', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.SubformsDesignRs.decode(res)];
            }
        });
    });
}
exports.SubformsDesign = SubformsDesign;
function SaveSubformsDesign(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.SaveSubformsDesignRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormSaveSubformsDesign', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.SaveSubformsDesignRs.decode(res)];
            }
        });
    });
}
exports.SaveSubformsDesign = SaveSubformsDesign;
function ActionsDesign(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.ActionsDesignRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormActionsDesign', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.ActionsDesignRs.decode(res)];
            }
        });
    });
}
exports.ActionsDesign = ActionsDesign;
function SaveActionsDesign(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.SaveActionsDesignRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormSaveActionsDesign', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.SaveActionsDesignRs.decode(res)];
            }
        });
    });
}
exports.SaveActionsDesign = SaveActionsDesign;
function SaveTableViewColumnsDesign(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.form.SaveTableViewColumnsDesignRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NFormSaveTableViewColumnsDesign', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.form.SaveTableViewColumnsDesignRs.decode(res)];
            }
        });
    });
}
exports.SaveTableViewColumnsDesign = SaveTableViewColumnsDesign;
function SystemPackages(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.ngen.SystemPackagesRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NGenSystemPackages', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.ngen.SystemPackagesRs.decode(res)];
            }
        });
    });
}
exports.SystemPackages = SystemPackages;
function PackageChange(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.ngen.PackageChangeRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NGenPackageChange', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.ngen.PackageChangeRs.decode(res)];
            }
        });
    });
}
exports.PackageChange = PackageChange;
function PackageSet(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.ngen.PackageSetRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NGenPackageSet', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.ngen.PackageSetRs.decode(res)];
            }
        });
    });
}
exports.PackageSet = PackageSet;
function UploadImage(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.ngen.UploadImageRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NGenUploadImage', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.ngen.UploadImageRs.decode(res)];
            }
        });
    });
}
exports.UploadImage = UploadImage;
// export async function getStatusAlertsList(req: priority.netitems.bpm.StatusAlertsListRq, signal?: AbortSignal) {
//   const req64 = priority.netitems.bpm.StatusAlertsListRq.encode(req).finish();
//   const res = await sendHttpRequest(req64, 'NAlertStatusAlertsList', req.Properties, signal);
//   return priority.netitems.bpm.StatusAlertsListRs.decode(res);
// }
// export async function getStatusLinkAlertsList(req: priority.netitems.bpm.StatusLinkAlertsListRq, signal?: AbortSignal) {
//   const req64 = priority.netitems.bpm.StatusAlertsListRq.encode(req).finish();
//   const res = await sendHttpRequest(req64, 'NAlertStatusAlertsList', req.Properties, signal);
//   return priority.netitems.bpm.StatusLinkAlertsListRq.decode(res);
// }
function GetMessageColumns(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.nrule.GetMessageColumnsRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NRuleGetMessageColumns', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.nrule.GetMessageColumnsRs.decode(res)];
            }
        });
    });
}
exports.GetMessageColumns = GetMessageColumns;
function GetCoverLetters(req, signal) {
    return __awaiter(this, void 0, void 0, function () {
        var req64, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req64 = nform_1.priority.netitems.nrule.GetCoverLettersRq.encode(req).finish();
                    return [4 /*yield*/, sendHttpRequest(req64, 'NRuleGetCoverLetters', req.Properties, signal)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, nform_1.priority.netitems.nrule.GetCoverLettersRs.decode(res)];
            }
        });
    });
}
exports.GetCoverLetters = GetCoverLetters;
